import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://relatorios.tanaescola.com/api',
  //baseURL: 'http://localhost:5058/api',
});

instance.interceptors.request.use(
  (config) => {
    config.headers['apiKey'] = '$2a$16$jnPa1Yl0rslEH1kkmT4a1.7UgfPp6S0HHVQx7H.Ohy7q3L1jZJQz.';
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;